import { Component, OnInit } from '@angular/core';
import { OappService } from './shared/services/oapp.service';
import { Router } from '@angular/router';
import { NetsolinService } from "src/app/shared/services/netsolin.service";
import { GlobalService } from './shared/services/global.service';
import { AutoLogoutService } from './shared/services/auto-logout.service'
// import { GlobalService } from './shared/services/global.service';
import { StorageService } from './shared/services/storage/storage.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'cercanos-propiedad-horizontal';

  constructor(private oapp: OappService, private router: Router, private globalS: GlobalService, public netsolinService: NetsolinService, private ALservice:AutoLogoutService, private storageService: StorageService) {


  }
  ngOnInit() {

  }
}
